import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'

import { sendPhoneVerificationCode, verifyPhoneNumber } from '../../actions/asyncMember'
import { cleanMemberStatus } from '../../actions/member'

const VerifyPhone = props => {
    const { t } = useTranslation();
    const countdownTime = 60
    const [open, setOpen] = useState(true)
    const [timer, setTimer] = useState(false);
    const [second, setSecond] = useState(countdownTime);
	const { form, verifyPhoneSucc, verifyPhoneFail, cleanMemberStatus } = props
    const { getFieldProps } = form
    
    useEffect(() => {
        let interval
        if (timer) {
            interval = setInterval(() => {
                setSecond(preSecond => {
                    if (preSecond <= 1) {
                        setTimer(false)
                        clearInterval(interval)
                        return countdownTime
                    } else {
                        return preSecond - 1
                    }
                })
            }, 1000)
        }
        return () => clearInterval(interval)
    }, [timer])
	
	useEffect(() => {
        if(verifyPhoneSucc) {
            setOpen(false)
            cleanMemberStatus()
		}
    }, [verifyPhoneSucc])
	
    const UpdatePhone = () => {
        props.form.validateFields((error, value) => {
            if (!error) {
                props.verifyPhoneNumber(value.phone, value.verificationCode)
            }
        })
    }

    const getVerificationCode = () => {
        props.form.validateFields((error, value) => {
            if(!!error && !!error.phone) return ;
            setTimer(true)
            props.sendPhoneVerificationCode(value.phone)
        })
    }

    return (
        <Dialog className="dialog" open={open} onClose={() => {}} fullWidth>
            <DialogTitle disableTypography style={{ padding: '32px 32px 20px' }}>
                <Grid container justify="space-between" alignItems="center">
                    <Typography style={{ fontSize: '20px' }}>太棒了！ 剩最後一個步驟：電話號碼驗證</Typography>
                </Grid>
            </DialogTitle>
            <div className="d-flex align-items-center" style={{ margin: '15px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogContent>
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Grid item md={2}>
                        <Typography className="text-grey">{t('phone')}</Typography>
                    </Grid>
                    <Grid item md={5}>
                        <Grid container alignItems="center">
                            <TextField
                                margin="dense"
                                name="phone"
                                id="phone"
                                variant="outlined"
                                type="number"
                                fullWidth
                                inputProps={{
                                    ...getFieldProps('phone', {
                                        initialValue: '',
                                        rules: [{
                                            required: true,
                                            type: 'string',
                                            pattern: /^[0-9]{10}$/,
                                        }]
                                    })
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item md={5}>
                    {timer
                        ?
                            <Typography
                                className="text-grey"
                                style={{ marginLeft: '10px' }}
                            >
                                重新發送({second})
                            </Typography>
                        :
                            <Typography
                                color="primary"
                                className="pointer"
                                style={{ marginLeft: '10px' }}
                                onClick={getVerificationCode}
                            >
                                {t('get_verification_code')}
                            </Typography>
                    }
                    </Grid>
                </Grid>
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Grid item md={2}>
                        <Typography className="text-grey">{t('verification_code')}</Typography>
                    </Grid>
                    <Grid item md={5}>
                        <Grid container alignItems="center">
                            <TextField
                                margin="dense"
                                name="verification_code"
                                id="verification_code"
                                variant="outlined"
                                fullWidth
                                inputProps={{
                                    ...getFieldProps('verificationCode', {
                                        initialValue: '',
                                        rules: [{
                                            required: true,
                                            type: 'string',
                                        }]
                                    })
                                }}
                            />
                        </Grid>
                        
                    </Grid>
                    <Grid item md={5}>
                        {verifyPhoneFail &&
                            <Typography
                                color="error"
                                className="pointer"
                                style={{ marginLeft: '10px' }}
                            >
                                *驗證碼有誤
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <div className="d-flex align-items-center" style={{ margin: '0px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogActions className="dialog-func">
                <Grid container justify="flex-end" alignItems="center" style={{ marginTop: '20px' }}>
                    <Button color="primary" variant="contained" onClick={UpdatePhone}>
						完成註冊
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default connect(
    state => ({
        verifyPhoneSucc: state.member.verifyPhoneSucc,
        verifyPhoneFail: state.member.verifyPhoneFail,
	}),
    {
        sendPhoneVerificationCode,
        verifyPhoneNumber,
        cleanMemberStatus,
    }
)(createForm()(VerifyPhone))